
export default function (rows,sorters){

    var sortDirections = _.map(sorters, 'direction')

    var sortFunctions = _.map(sorters,function(s){
      var id = s.id
      var sortFunction = function(row){
        return _.find(row.columns,{id:id}).value
      }
      return sortFunction
    })

    var data = _.orderBy(rows,sortFunctions,sortDirections)

    return data

}


// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/lib/update/sort/sort.js